export default __webpack_public_path__ + "static/media/rounded-polygon.dff54a81.svg";